function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { SelectGroupButton, TextOverflow } from './styles';
import PropTypes from 'prop-types';
import React from 'react';
import { Text } from '@doordash/design-language';
import { TypeNames } from './constants';
import { getButtonTextStyles } from './utils';

var GroupButton = function GroupButton(_ref) {
  var buttonElementProps = _ref.buttonElementProps,
      index = _ref.index,
      isDisabled = _ref.isDisabled,
      isInline = _ref.isInline,
      isSelected = _ref.isSelected,
      option = _ref.option,
      size = _ref.size,
      kind = _ref.kind;
  return /*#__PURE__*/React.createElement(SelectGroupButton, _extends({
    key: index,
    isDisabled: isDisabled,
    isInline: isInline,
    isSelected: isSelected,
    kind: kind,
    size: size,
    type: "button"
  }, buttonElementProps), /*#__PURE__*/React.createElement(Text, {
    styles: Text.Styles[getButtonTextStyles(size)],
    color: Text.Colors.CurrentColor
  }, /*#__PURE__*/React.createElement(TextOverflow, {
    size: size
  }, option)));
};

GroupButton.propTypes = {
  index: PropTypes.number,
  buttonElementProps: PropTypes.object,
  size: PropTypes.number,
  kind: PropTypes.oneOf(Object.values(TypeNames)),
  isDisabled: PropTypes.bool,
  isInline: PropTypes.bool,
  isSelected: PropTypes.bool,
  option: PropTypes.string
};
export default GroupButton;